import React, { useMemo } from 'react';
import { BusTrailerChecklistType, ChecklistDataEntry, StudentChecklistValue } from './types';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import ChecklistValueCell from './ChecklistValueCell';
import Table from './Table';

type BusTrailerChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	medicalCheck: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};

const columnHelper = createColumnHelper<BusTrailerChecklistDataEntry>();

const BusTrailerChecklist = ({ checklist }: { checklist: BusTrailerChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('medicalCheck', {
				header: 'Medische Keuring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			medicalCheck: entry.values.find((value) => value.option.name === 'Medische Keuring') || {
				value: null,
			},
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default BusTrailerChecklist;
